import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Line } from '@paragon/contract-library';

interface LinesState {
  [lineGuid: string]: Line;
}

const initialState: LinesState = {};

const linesSlice = createSlice({
  name: 'lines',
  initialState,
  reducers: {
    linesLoaded: (state, action: PayloadAction<readonly Line[]>) => {
      for (const line of action.payload) {
        state[line.guid] = line;
      }
    },
  },
});

export const { linesLoaded } = linesSlice.actions;
export const lines = linesSlice.reducer;
